module.exports = __webpack_public_path__ + "media/img/stop-sales-73cdfac4f55027e1c97c12ffb9fb0d35.png";